import script from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"

import "./PreferenceView.vue?vue&type=style&index=0&id=20b30c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b30c3e"]])

export default __exports__